'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _RightOutlined = _interopRequireDefault(require('./lib/icons/RightOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _RightOutlined;
exports.default = _default;
module.exports = _default;